import { Card } from 'app/components/card';
import styles from '../voip-common.module.scss';

export const NoRuleCard = ({ message }: { message: string }) => {
  return <Card className={styles.noRule}>{message}</Card>;
};
